export default{
    // @BusinessContract
    newCreatedBusinessContract:(state) =>{
        return state.newCreatedBusinessContract
    }
}